import { compare } from '../unknowns/compare';

export const substractArrays = <T, P = T>(
  array1: T[],
  array2: P[],
  equalityCondition: (el1: T, el2: P) => boolean = compare
) => array1.filter(el1 => !array2.some(el2 => equalityCondition(el1, el2)));
